import React from "react";
import { useStats } from "react-instantsearch";

const SearchResultsStats = () => {
  const { nbHits, processingTimeMS } = useStats();

  return (
    <h6 className="search-results-for">
      {nbHits.toLocaleString()} results in {processingTimeMS}ms
    </h6>
  );
};

export default SearchResultsStats;
